'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _wendysKennyLoggins = require('wendys-kenny-loggins');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConsoleAppender = function (_BaseAppender) {
	_inherits(ConsoleAppender, _BaseAppender);

	function ConsoleAppender(config) {
		_classCallCheck(this, ConsoleAppender);

		var _this = _possibleConstructorReturn(this, (ConsoleAppender.__proto__ || Object.getPrototypeOf(ConsoleAppender)).call(this, config));

		var consoleContext = config.context ? config.context : _this;
		// FIXME: Context binding console may not work in IE
		_this.contextInfoLogger = console.info.bind(consoleContext);
		_this.contextWarnLogger = console.warn.bind(consoleContext);
		_this.contextErrorLogger = console.error.bind(consoleContext);
		_this.contextTraceLogger = console.trace.bind(consoleContext);
		return _this;
	}

	_createClass(ConsoleAppender, [{
		key: 'append',
		value: function append(events) {
			var _this2 = this;

			if (!Array.isArray(events)) {
				return false;
			}
			events.forEach(function (event) {
				return _this2.consoleHandler(event);
			});
		}
	}, {
		key: 'consoleHandler',
		value: function consoleHandler(event) {
			var message = event.message || '';
			switch (event.level) {
				case 'FATAL':
				case 'ERROR':
					this.contextErrorLogger(message, event);
					return true;
				case 'WARN':
					this.contextWarnLogger(message, event);
					return true;
				case 'DEBUG':
				case 'INFO':
					this.contextInfoLogger(message, event);
					return true;
				case 'TRACE':
					this.contextTraceLogger(message, event);
					return true;
				default:
					return false;
			}
		}
	}]);

	return ConsoleAppender;
}(_wendysKennyLoggins.BaseAppender);

exports.default = ConsoleAppender;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins-console-appender/lib/ConsoleAppender.js
// module id = 889
// module chunks = 0